import type { CandidateOriginApi } from '@/modules/candidates/types';

/**
 * The Source filter's URL parameter. The hiring manager platform calls a
 * candidate's Candidate Origin its "Source"; the code keeps "origin".
 */
export const ORIGIN_PARAM = 'origin';

const originsByParam: Record<string, CandidateOriginApi> = {
  inbound: 'Inbound',
  outbound: 'Outbound',
};

/** The filtered origin, or undefined for every source. */
export const parseOrigin = (
  value: string | null,
): CandidateOriginApi | undefined =>
  value && Object.hasOwn(originsByParam, value)
    ? originsByParam[value]
    : undefined;

export const toOriginParam = (origin: CandidateOriginApi) =>
  origin.toLowerCase();
